import type { FC } from 'react'
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { tss } from '@dhl/theme'
import { ChevronLeft } from '@dhl/icons'

type Props = {
  onNavigateBack: () => void
}

const useStyles = tss.makeStyles()((theme) => ({
  backLinkMenuItem: {
    color: theme.palette.primary.main,
    '&> div, svg': {
      color: theme.palette.primary.main,
    },
  },
}))

export const SideMenuBackLink: FC<Props> = ({ onNavigateBack }) => {
  const { classes } = useStyles()
  const { t } = useTranslation()

  return (
    <ListItemButton
      onClick={onNavigateBack}
      aria-label="Navigate back"
      data-test="side-navigation-back"
      className={classes.backLinkMenuItem}
    >
      <ListItemIcon>
        <ChevronLeft />
      </ListItemIcon>
      <ListItemText color="primary">{t('components.page.sideMenu.navigateBackToMenu')}</ListItemText>
    </ListItemButton>
  )
}
